const KEY = 'papr_analytics_consent'
export type ConsentState = 'granted' | 'denied' | 'unset'

/**
 * Consent state ONLY. This module is pure state (localStorage) — it does not import,
 * init, or touch PostHog. Starting the SDK is owned solely by getAnalytics() (client.ts),
 * which lazily inits on first real use once consent is 'granted'.
 */
export function readConsent(): ConsentState {
  if (typeof window === 'undefined') return 'unset'
  const v = window.localStorage.getItem(KEY)
  return v === 'granted' || v === 'denied' ? v : 'unset'
}

export function grantConsent(): void {
  if (typeof window !== 'undefined') window.localStorage.setItem(KEY, 'granted')
}

export function denyConsent(): void {
  if (typeof window !== 'undefined') window.localStorage.setItem(KEY, 'denied')
}
